module.exports = __webpack_public_path__ + "static/media/text-image.d4d2b916.webp";